module.exports = __webpack_public_path__ + "img/mail-envelope-open.6de4cac3.svg";